import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { componentTypes } from '@white-nl/instantsearch-components';

import AngleDown from '../icon/regular/AngleDown';

export default function SortBy({ sortBy }: componentTypes.SortByProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const [isActive, setIsActive] = useState(false);

  const handleToggleClick = useCallback(() => {
    setIsActive(!isActive);
  }, [isActive, setIsActive]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsActive(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const {
    options,
    currentRefinement,
    canRefine,
    refine,
  } = sortBy;

  if (!canRefine) {
    return null;
  }

  const selectedValue = options.filter((item) => item.value === currentRefinement)[0];

  return (
    <div
      ref={dropdownRef}
      className={`${isActive ? 'active ' : ''}group/dropdown relative z-15`}
    >
      <button
        className="text-sm lg:text-base font-semibold text-gray-950 leading-none p-3 lg:p-4 cursor-pointer border border-gray-950/10 lg:border-current rounded-sm inline-flex items-center gap-x-3 justify-between transition hover:border-pink-400 hover:text-pink-400 group-[.active]/dropdown:rounded-b-none group-[.active]/dropdown:bg-gray-80 group-[.active]/dropdown:border-gray-80 group-[.warning]/dropdown:text-pink-400 min-w-[180px]"
        type="button"
        onClick={handleToggleClick}
      >
        {selectedValue.label}
        <AngleDown className="w-3 lg:w-3.75 fill-current transition-transform group-[.active]/dropdown:rotate-180" />
      </button>
      <div className="hidden text-base absolute bg-white pe-2 py-2 top-full left-0 w-full shadow-drop rounded-b-sm group-[.active]/dropdown:block">
        <ul className="custom-scroll max-h-117 overflow-x-hidden overflow-y-auto">
          {options.map((option) => (
            <li
              key={option.value}
              className="group/dropdown-item leading-[1.2] py-2 ps-3 pe-4.5 -me-2"
            >
              <button
                className="flex w-100 no-underline hover:decoration-pink-400 cursor-pointer"
                type="button"
                onClick={() => {
                  refine(option.value);
                  setIsActive(false);
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
